var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 6.333C19.2 7.867 20 9.867 20 12c0 4.4-3.6 8-8 8-1.333 0-2.667-.333-3.8-1L4 20l1.067-4C4.4 14.8 4 13.4 4 12c0-4.4 3.6-8 8-8 2.133 0 4.133.8 5.667 2.333zm-1.734 8.534c.134-.467.134-.867.134-.934-.067-.066-.2-.133-.4-.2-.2-.066-1.2-.6-1.334-.666-.2-.067-.333-.134-.466.066-.134.2-.534.667-.6.8-.134.134-.2.134-.4.067-.2-.133-.867-.333-1.6-1-.6-.533-1-1.2-1.134-1.4-.133-.2 0-.333.067-.4s.2-.2.267-.333c.133-.134.133-.2.2-.334.066-.133.066-.266 0-.333C10.6 10 10.2 9.067 10 8.667c-.133-.334-.333-.334-.467-.334h-.4C9 8.333 8.8 8.4 8.6 8.6s-.733.667-.733 1.667.733 1.933.8 2.066c.066.134 1.4 2.2 3.4 3 1.666.667 2 .534 2.4.467.466-.067 1.266-.467 1.466-.933z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.024aa1f144c0259ea66ce2cefa6fabd5.svg";
export { ForwardRef as ReactComponent };